var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.38159,
    cy: 9.35986,
    r: 8,
    stroke: "#95AABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62159 6.39586C10.1856 6.39586 10.5816 5.98786 10.5816 5.45986C10.5816 4.96786 10.1736 4.59586 9.62159 4.59586C9.06959 4.59586 8.66159 4.99186 8.66159 5.49586C8.66159 5.99986 9.06959 6.39586 9.62159 6.39586ZM8.86559 13.8599H10.3656V7.45186H8.86559V13.8599Z",
    fill: "#95AABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.a04f2e419786eb13b84964c3139de67e.svg";
export { ForwardRef as ReactComponent };